module.exports = __webpack_public_path__ + "media/images/topsec_2-1050877d2793358b3bc9c726cca9398f.png";